// import React from 'react';
import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../components/panel/panel.jsx";
import classnames from "classnames";

import Config from "../../Config.js";

import {
  GetDominUrl
} from "../../api/apiconfiguration.js"

import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import QRCode from "qrcode.react";
import DOMPurify from "dompurify";
import { videoTagString, VideoTag } from "react-video-tag";
import ModalVideo from "react-modal-video";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { NumericFormat } from "react-number-format";
import YouTube from "react-youtube";
import renderHTML from "react-render-html";
require("codemirror/mode/xml/xml.js");
require("codemirror/mode/javascript/javascript.js");

const Articleinfopage = ({ props }) => {
  console.log("props", props);
  const location = useLocation();
  let history = useHistory();
  const [ProductID, setProductID] = useState(location?.state?.ProductID);
  const [activePill, setactivePill] = useState("0");
  const [articleSegmentList, setarticleSegmentList] = useState([]);
  const [articleSegmentWebLinkList, setarticleSegmentWebLinkList] = useState(
    []
  );
  const [SegmentDescription, setSegmentDescription] = useState("");
  const [SegmentDescriptionError, setSegmentDescriptionError] = useState("");
  const [VideosegmentList, setVideosegmentList] = useState([]);
  const [ArticleSegmentDocumentlist, setArticleSegmentDocumentlist] = useState(
    []
  );
  const [ArticleSegmentImageLists, setArticleSegmentImageLists] = useState([]);
  const [ArticleSegmentID, setArticleSegmentID] = useState("");
  const [ArticleName, setArticleName] = useState("");
  const [variantList, setvariantList] = useState("");
  const [articleImage, setarticleImage] = useState([]);
  const [articleCategoryName, setarticleCategoryName] = useState([]);
  const [articlesubCategoryName, setarticlesubCategoryName] = useState([]);
  const [articlePrice, setarticlePrice] = useState("");
  const [articleRegularPrice, setarticleRegularPrice] = useState("");
  const [Currency, setCurrency] = useState(null);
  const [articlelable, setarticlelable] = useState("");
  const [articlelableImagePath, setarticlelableImagePath] = useState("");
  const [articleinfo, setarticleinfo] = useState(null);
  const [articleeSegmenttitle, setarticleeSegmenttitle] = useState("");
  //Video Player
  const [isOpen, setOpen] = useState(false);
  const [VideoPlayerFilePath, setVideoPlayerFilePath] = useState("");

  const [ModalVideoPlayer, setModalVideoPlayer] = useState(false);
  const [VideoPlayerItem, setVideoPlayerItem] = useState("");
  const [segmentinfo, setsegmentinfo] = useState(null);
  const [shortDescription, setShortDescription] = useState("");


  const domainFrontUrl = useRef("");

  const reyurnperamiter = (item) => {
    let itemobj = item.split("https://www.youtube.com/watch");
    console.log("item", itemobj);
    return new URLSearchParams(itemobj[1]).get("v");
    //    console.log("IdPraveen=>",ID)
  };
  const toggleVideoPlayer = (item) => {
    console.log("item===>", item);
    setModalVideoPlayer(!ModalVideoPlayer);
    setVideoPlayerItem(item);
  };
  const opts = {
    height: "200",
    width: "280",
    // playerVars: {
    //     // https://developers.google.com/youtube/player_parameters
    //     autoplay: 1,
    // },
  };
  const downloadImage = (Url, filename) => {
    window.open(Config.contentUrl + Url, "_blank");
    // Url = Config.contentUrl + Url;
    //saveAs(Url, filename) // Put your image url here.
  };

  useEffect(() => {
    let checkLogin = localStorage.getItem("loginUserID");
    if (
      checkLogin === "" ||
      checkLogin === null ||
      checkLogin === "null" ||
      checkLogin === undefined
    ) {
      history.push("/Login");
    }
  }, []);
  useEffect(() => {
    getDominUrl()
    GetAllProductInfo(ProductID);
  }, []);


  const getDominUrl = async () => {
    let response = await GetDominUrl();
    if (response !== null && response.domainName !== null && response.domainName !== "") {
      domainFrontUrl.current = response.domainName;
    }
    else {
      domainFrontUrl.current = "";
    }
  }

  const togglePill = (pill) => {
    if (activePill !== pill) {
      setactivePill(pill);
    }
  };
  const ArticleSegmentchanged = (item, Index) => {
    let Tempsegment = [...articleSegmentList];
    if (Tempsegment.length > 0) {
      Tempsegment.map((SegmentItem) => {
        if (SegmentItem._id === item._id) {
          SegmentItem.isDeleted = true;
        } else {
          SegmentItem.isDeleted = false;
        }
      });
    }
    ArticleSegmentgetbyId(item._id);
    setarticleSegmentList(Tempsegment);
  };

  const GetAllProductInfo = (articleidObj) => {
    if (
      articleidObj !== null &&
      articleidObj !== "" &&
      articleidObj !== undefined &&
      articleidObj !== "undefined"
    ) {
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      fetch(
        Config.apiUrl +
        "ArticleProduct/GetArticleAllInformation?id=" +
        articleidObj,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((resp1) => {
        resp1.json().then((result) => {
          if (result != null) {
            console.log("resultinformation=>", result);
            setarticleinfo(result);
            setShortDescription(result?.shortDescription ? result?.shortDescription : "")
            setArticleName(result.articleName);
            if (result.categorydetail != null && result.categorydetail != "") {
              setarticleCategoryName(result.categorydetail.name);
              if (
                result.subCategoryDetail != null &&
                result.subCategoryDetail != ""
              ) {
                setarticlesubCategoryName(result.subCategoryDetail.name);
              }
            }
            if (
              result.articleAttribute != null &&
              result.articleAttribute != ""
            ) {
              setvariantList(result.articleAttribute);
            }
            if (result.sellPrice != null && result.sellPrice != "") {
              setarticlePrice(result.sellPrice);
            } else {
              setarticlePrice("0");
            }
            if (result.regularPrice != null && result.regularPrice != "") {
              setarticleRegularPrice(result.regularPrice);
            } else {
              setarticleRegularPrice("0");
            }
            if (
              result?.currencyDetail != null &&
              result?.currencyDetail != undefined &&
              result?.currencyDetail != ""
            ) {
              setCurrency(result?.currencyDetail?.otherName);
            }
            if (result.labelDetail != null && result.labelDetail != "") {
              setarticlelable(result.labelDetail.name);
              setarticlelableImagePath(
                Config.contentUrl + result.labelDetail.logoPath
              );
            }

            if (
              result.aarticleProductSegment != null &&
              result.aarticleProductSegment != ""
            ) {
              result.aarticleProductSegment[0].isDeleted = true;
              setarticleSegmentList(result.aarticleProductSegment);
              var first = result.aarticleProductSegment[0];
              ArticleSegmentgetbyId(first._id);
            }
          } else {
            setarticleSegmentList([]);
          }
        });
      });
    }
  };
  const ArticleSegmentgetbyId = (ArticleSegmentID) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(
      Config.apiUrl +
      "ArticleProductSegment/SegmentFileById?segmentid=" +
      ArticleSegmentID,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
      }
    ).then((response) => {
      response.json().then((result) => {
        console.log("resultinformationSegment=>", result);
        if (result !== null) {
          setsegmentinfo(result);
          setarticleeSegmenttitle(result.title);
          //setArticleID(result.articleID);
          if (result.description != null) {
            setSegmentDescription(result.description);
          } else {
            setSegmentDescription("");
          }

          if (result.articleVideo != null) {
            setVideosegmentList(result.articleVideo);
          } else {
            setVideosegmentList([]);
          }
          if (result.articleDocument != null) {
            setArticleSegmentDocumentlist(result.articleDocument);
          } else {
            setArticleSegmentDocumentlist([]);
          }
          if (result.articleExternalLinkList != null) {
            setarticleSegmentWebLinkList(result.articleExternalLinkList);
          } else {
            setarticleSegmentWebLinkList([]);
          }
          if (result.articleSegmentImage != null) {
            setArticleSegmentImageLists(result.articleSegmentImage);
          } else {
            setArticleSegmentImageLists([]);
          }
          setArticleSegmentID(ArticleSegmentID);
        }
      });
    });
  };

  const EditArticleDetails = (ArticleIdObj) => {
    if (ArticleIdObj === "") {
      props.history.push("Login1");
    } else {
      history.push({
        pathname: "/article-addnew",
        state: { EditArticleDetailsID: ArticleIdObj },
      });
    }
  };

  const convertHtml = (htmlInput) => {
    if (htmlInput != null && htmlInput != "" && htmlInput != undefined) {
      const mySafeHTML = DOMPurify.sanitize(htmlInput);
      return <div dangerouslySetInnerHTML={{ __html: mySafeHTML }} />;
    }
  };
  const OpenExternallink = (url) => {
    if (!url.match(/^https?:\/\//i)) {
      url = "http://" + url;
    }
    window.open(url, "_blank");
    //window.open(url, "blank");
    //window.open(url, "_blank", "").focus();
    // window.location.href = url;
    // Object.assign(document.createElement('a'), {
    //     target: '_blank',
    //     href: url,
    //   }).click();
  };
  return (
    <div>
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item">
          <a href="/home">Home</a>
        </li>

        <li className="breadcrumb-item active">Article information</li>
      </ol>
      <h1 className="page-header">Article information</h1>
      {articleinfo && (
        <>
          <Panel>
            <PanelHeader>
              <div>
                Article
                {/* <Link to="addnew" type="button" className="btn btn-primary shadow-add  m-l-10 ">
                            <i class='fas fa-lg fa-fw m-r-5 fa-pencil-alt icon'></i>
                            Edit
                        </Link> */}
                {articleinfo?.isshow ? (
                  <button
                    className="btn btn-primary shadow-add  m-l-10 "
                    onClick={(e) => {
                      EditArticleDetails(ProductID);
                    }}
                  >
                    <i class="fas fa-lg fa-fw m-r-5 fa-pencil-alt icon"></i> Edit
                  </button>
                ) : (
                  <></>
                )}
              </div>
            </PanelHeader>
            <PanelBody>
              <div className="container-fluid">
                <div className="row">
                  <div className="col-xl-8 col-xxl-8 col-lg-12 col-md-12">
                    <div className="row ">
                      <div className="col-lg-7">
                        <div className="product-image-main-container">
                          <div className="tabimgmaincontainer product-images">
                            {articleinfo?.articleImage?.length > 0 ? (
                              articleinfo?.articleImage?.map((item, i) => (
                                <button className="Link">
                                  <img
                                    src={Config.contentUrl + item?.filePath}
                                    alt="img"
                                  />
                                </button>
                              ))
                            ) : (
                              <></>
                            )}
                          </div>


                          {articleinfo?.articleImage?.length > 0 ? (
                            <div className="main-product-image">
                              <img
                                src={
                                  Config.contentUrl +
                                  articleinfo?.articleImage[0].filePath
                                }
                                style={{ marginLeft: 10 }}
                                height="400px"
                                width="100%"
                                className="rounded"
                              />
                            </div>

                          ) : (
                            <></>
                          )}

                        </div>
                      </div>

                      <div className="col-lg-5">

                        <h2 className="mb-0"> {ArticleName}</h2>
                        {articlePrice !== "0" ? (
                          <div className="d-flex">
                            <h4 className="mb-2 mr-2 text-decoration-line-through text-red">
                              <NumericFormat
                                prefix={Currency ? Currency : ""}
                                displayType="text"
                                thousandSeparator={true}
                                className=""
                                placeholder="Regular Price"
                                decimalScale={2}
                                fixedDecimalScale={false}
                                value={articleRegularPrice}
                              />
                            </h4>
                            {"  "}
                            <h4 className="mb-2">
                              <NumericFormat
                                prefix={Currency ? Currency : ""}
                                displayType="text"
                                thousandSeparator={true}
                                className=""
                                placeholder="Regular Price"
                                decimalScale={2}
                                fixedDecimalScale={false}
                                value={articlePrice}
                              />
                            </h4>
                          </div>
                        ) : (
                          <h4 className="mb-2">
                            {(articleRegularPrice !== null && articleRegularPrice !== "" &&
                              articleRegularPrice !== undefined && articleRegularPrice !== 0 && articleRegularPrice !== "0") && (
                                <NumericFormat
                                  prefix={Currency ? Currency : ""}
                                  displayType="text"
                                  thousandSeparator={true}
                                  className=""
                                  placeholder="Regular Price"
                                  decimalScale={2}
                                  fixedDecimalScale={false}
                                  value={articleRegularPrice}
                                />
                              )}

                          </h4>
                        )}
                        {/* <div>
                          {variantList.length > 0 ? (
                            <>
                              <div className="titlebgcontainer">
                                <b className="mb-0">Variant Combination</b>
                              </div>
                              {
                                variantList.map((variantItem) => {
                                  return (
                                    <div className="form-group row m-t-3 m-b-0">
                                      <label className="col-form-label col-lg-12">
                                        {"Select" + " " + variantItem.attributeName}{" "}
                                      </label>
                                      <div className="col-lg-12">
                                        <select className="form-control">
                                          {variantItem.articleAttributeValue.length >
                                            0 ? (
                                            variantItem.articleAttributeValue.map(
                                              (variantsubItem) => {
                                                return (
                                                  <option val={variantsubItem._id}>
                                                    {variantsubItem.value}
                                                  </option>
                                                );
                                              }
                                            )
                                          ) : (
                                            <></>
                                          )}
                                          <option>Red</option>
                                        </select>
                                      </div>
                                    </div>
                                  );
                                })
                              }
                            </>
                          ) : (
                            <></>
                          )}
                        </div> */}
                      </div>
                      {/* Next  */}
                      <p className="col-lg-12 mt-3 ">
                        {shortDescription !== null &&
                          shortDescription !== "" ? (
                          <>
                            <div className="titlebgcontainer">
                              <b className="mb-0">
                                Description{" "}
                              </b>
                            </div>
                            <div className="ckeditor-text-new" style={{ padding: '10px', overflow: 'scroll' }}>
                              {renderHTML(shortDescription)}
                            </div>
                          </>
                        ) : (
                          <></>
                        )}

                      </p>
                    </div>
                  </div>
                  <div className="col-xl-4 col-xxl-4 col-lg-12 col-md-12">
                    <div className="row">
                      <div className="col-sm-12">
                        <div>
                          <div className="titlebgcontainer">
                            <b className="mb-0">Qr Code </b>
                          </div>
                          <div className="row py-2 px-2">
                            <div className="col-xs-12 text-center">
                              {articleinfo?.qrCodePath !== null &&
                                articleinfo?.qrCodePath !== "" &&
                                articleinfo?.qrCodePath !== undefined ? (
                                <QRCode
                                  value={domainFrontUrl.current + articleinfo?.qrCodePath}
                                  id="qrCodeEl"
                                  style={{ height: 250, width: 250, marginTop: 10 }}
                                />
                              ) : (
                                <img
                                  src="/assets/img/new-Images/qr-code-scanner.jpg"
                                  style={{ height: "200px" }}
                                ></img>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </PanelBody>
          </Panel>
          <Panel>
            <PanelHeader>
              <div>
                Article Description
                {articleinfo?.isshow ? (
                  <button
                    className="btn btn-primary shadow-add  m-l-10 "
                    onClick={(e) => {
                      EditArticleDetails(ProductID);
                    }}
                  >
                    <i class="fas fa-lg fa-fw m-r-5 fa-pencil-alt icon"></i> Edit
                  </button>
                ) : (
                  <></>
                )}
              </div>
            </PanelHeader>
            <PanelBody>
              <Nav className="mb-3" pills>
                {articleSegmentList.map((x, i) => {
                  return (
                    <NavItem className="mr-2">
                      <NavLink
                        className={classnames({ active: x.isDeleted === true })}
                        //</NavItem>onClick={() => { togglePill('1'); }}
                        onClick={(e) => {
                          ArticleSegmentchanged(x, i);
                        }}
                      >
                        <span className="d-sm-none">
                          {x.title}{" "}
                          {articleinfo?.isArticleDescriptionDisplay === true ? (
                            <small className="mb-0 text-success">
                              <b>( Published ) </b>
                            </small>
                          ) : (
                            <small className="mb-0 text-danger">
                              <b>( Unpublished )</b>
                            </small>
                          )}
                        </span>
                        <span className="d-sm-block d-none">
                          {x.title}{" "}
                          {articleinfo?.isArticleDescriptionDisplay === true ? (
                            <small className="mb-0 text-success">
                              <b>( Published )</b>
                            </small>
                          ) : (
                            <small className="mb-0 text-danger">
                              <b>( Unpublished )</b>
                            </small>
                          )}
                        </span>
                      </NavLink>
                    </NavItem>
                  );
                })}
              </Nav>
              {articleinfo ? (
                <TabContent className="p-15 rounded bg-white mb-4">
                  <TabPane>
                    <Panel className="border" theme="success">
                      <PanelHeader>
                        {/* Product  Detail */}


                        {articleeSegmenttitle}
                      </PanelHeader>
                      <PanelBody>
                        <div className="container" style={{ overflow: "scroll" }}>
                          <div className="row">
                            <div className="col-xxl-5 col-xl-5 col-lg-12 col-md-12 mt-2">
                              {ArticleSegmentImageLists?.length > 0 ? (
                                <div className="titlebgcontainer mb-5">
                                  <b className="mb-0">
                                    Product Images{" "}
                                    {segmentinfo?.isArticleSegmentImageDisplay ===
                                      true ? (
                                      <small className="mb-0 text-success">
                                        <b>( Published </b>)
                                      </small>
                                    ) : (
                                      <small className="mb-0 text-danger">
                                        <b>( Unpublished )</b>
                                      </small>
                                    )}
                                  </b>
                                </div>
                              ) : (
                                <></>
                              )}
                              <div className="row ">
                                <div className="col-sm-3 tabimgmaincontainer ">
                                  {ArticleSegmentImageLists?.length > 0 ? (
                                    ArticleSegmentImageLists?.map((item, i) => (
                                      <button className="Link">
                                        <img
                                          src={Config.contentUrl + item.filePath}
                                          alt="img"
                                        />
                                      </button>
                                    ))
                                  ) : (
                                    <></>
                                  )}
                                  {/* <button className='Link'>
                                                            <img src="../assets/img/user/user-1.jpg" alt="img" />
                                                        </button>
                                                        <button className='Link'>
                                                            <img src="../assets/img/user/user-1.jpg" alt="img" />
                                                        </button>
                                                        <button className='Link'>
                                                            <img src="../assets/img/user/user-1.jpg" alt="img" />
                                                        </button>
                                                        <button className='Link'>
                                                            <img src="../assets/img/user/user-1.jpg" alt="img" />
                                                        </button> */}
                                </div>
                                {ArticleSegmentImageLists?.length > 0 ? (
                                  <div className="col-sm-9">
                                    {/* <img src="../assets/img/user/user-1.jpg" alt="img" height='250px' /> */}
                                    <img
                                      src={
                                        Config.contentUrl +
                                        ArticleSegmentImageLists[0].filePath
                                      }
                                      height="250px"
                                      width={"100%"}
                                    />
                                  </div>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                            <div className="col-xl-7 col-xxl-7 col-lg-12 col-md-12 mt-2">
                              <div className="row">
                                <div className="col-md-12">
                                  {SegmentDescription.length > 0 ? (
                                    <div>
                                      <div className="titlebgcontainer">
                                        <b className="mb-0">
                                          Description{" "}
                                          {segmentinfo?.isArticleSegmentDescriptionDisplay ===
                                            true ? (
                                            <small className="mb-0 text-success">
                                              <b>( Published </b>)
                                            </small>
                                          ) : (
                                            <small className="mb-0 text-danger">
                                              <b>( Unpublished )</b>
                                            </small>
                                          )}
                                        </b>
                                      </div>
                                      <p className="px-3 py-3 mb-0">
                                        {/* {SegmentDescription} */}

                                        {SegmentDescription !== null &&
                                          SegmentDescription !== "" ? (
                                          // convertHtml(SegmentDescription)
                                          <div className="ckeditor-text-new">
                                            {renderHTML(SegmentDescription)}
                                          </div>
                                        ) : (
                                          <></>
                                        )}
                                      </p>
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                  {VideosegmentList.length > 0 ? (
                                    <div>
                                      <div className="titlebgcontainer">
                                        <b className="mb-0">
                                          Know more{" "}
                                          {segmentinfo?.isArticleSegmentVideoDisplay ===
                                            true ? (
                                            <small className="mb-0 text-success">
                                              <b>( Published </b>)
                                            </small>
                                          ) : (
                                            <small className="mb-0 text-danger">
                                              <b>( Unpublished )</b>
                                            </small>
                                          )}
                                        </b>
                                      </div>
                                      <div className="container-fluid px-3 py-3">
                                        <div className="row mt-4">
                                          {VideosegmentList.map((subscriber) => {
                                            return subscriber?.isYouTubeLink ===
                                              false ? (
                                              <div className="col-sm-4 text-center">
                                                <button
                                                  className="btn btn-link p-0 videotag bg-transparent"
                                                  onClick={() => {
                                                    setVideoPlayerFilePath(subscriber.filePath);
                                                    setOpen(true);
                                                  }}

                                                >
                                                  <VideoTag
                                                    src={
                                                      Config.contentUrl +
                                                      subscriber.filePath
                                                    }
                                                    className="image-article imageUpload m-auto"
                                                  />
                                                  <p className="videotagtext text2line breakword">
                                                    {subscriber.originalFileName}
                                                  </p>
                                                  <div className="youtubeicon">
                                                    <i className="fab fa-lg fa-fw fa-youtube"></i>
                                                  </div>
                                                </button>
                                                {/* <ModalVideo
                                                  channel="custom"
                                                  autoplay={true}
                                                  isOpen={isOpen}
                                                  url={
                                                    Config.contentUrl +
                                                    subscriber.filePath
                                                  }
                                                  onClose={() => setOpen(false)}
                                                /> */}
                                              </div>
                                            ) : (
                                              // : <div className='col-sm-4 text-center'>
                                              //     <iframe
                                              //         src="http://www.youtube.com/embed/XGSy3_Czz8k"
                                              //         className="image-article imageUpload m-auto" />
                                              //     <embed src={subscriber?.youTubeLink} className="image-article imageUpload m-auto" />

                                              //     <p className='mb-0'>
                                              //         {subscriber.originalFileName}
                                              //     </p>
                                              // </div>
                                              <>
                                                <div className="col-sm-4 text-center">
                                                  <button
                                                    className="btn btn-link p-0 videotag bg-transparent"
                                                    onClick={() => {
                                                      toggleVideoPlayer(
                                                        reyurnperamiter(
                                                          subscriber?.youTubeLink
                                                        )
                                                      );
                                                    }}
                                                  >
                                                    <img
                                                      src={`https://i.ytimg.com/vi/${reyurnperamiter(
                                                        subscriber?.youTubeLink
                                                      )}/hqdefault.jpg`}
                                                      className="image-article imageUpload m-auto"
                                                    />
                                                    <p className="videotagtext text2line breakword">
                                                      {subscriber.youTubeLink}
                                                    </p>

                                                    <div className="youtubeicon">
                                                      <i className="fab fa-lg fa-fw fa-youtube"></i>
                                                    </div>
                                                  </button>

                                                </div>
                                              </>
                                            );
                                          })}
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                  <Modal
                                    isOpen={ModalVideoPlayer}
                                    toggle={toggleVideoPlayer}
                                    className="text-center modalcenter YoutubeModal"
                                  >
                                    <ModalBody>
                                      <div>
                                        <YouTube
                                          videoId={VideoPlayerItem}
                                          opts={opts}
                                        />
                                      </div>
                                      <button
                                        className="btn btn-link modalcolsebtn"
                                        onClick={toggleVideoPlayer}
                                      >
                                        <i className="ion ion-md-close-circle fa-2x"></i>
                                      </button>
                                    </ModalBody>
                                  </Modal>
                                  <ModalVideo
                                    channel="custom"
                                    autoplay={true}
                                    isOpen={isOpen}
                                    url={
                                      Config.contentUrl +
                                      VideoPlayerFilePath
                                    }
                                    onClose={() => { setVideoPlayerFilePath(""); setOpen(false) }}
                                  />
                                  {articleSegmentWebLinkList.length > 0 ? (
                                    <div>
                                      <div className="titlebgcontainer">
                                        <b className="mb-0">
                                          Explore further{" "}
                                          {segmentinfo.isArticleSegmentWebLinkDisplay ===
                                            true ? (
                                            <small className="mb-0 text-success">
                                              <b>( Published </b>)
                                            </small>
                                          ) : (
                                            <small className="mb-0 text-danger">
                                              <b>( Unpublished )</b>
                                            </small>
                                          )}
                                        </b>
                                      </div>
                                      <div className="container-fluid px-3 py-2">
                                        <div className="row">
                                          {articleSegmentWebLinkList.map(
                                            (WebData) => {
                                              return (
                                                <div className="col-sm-12">
                                                  {/* <Link to={{ pathname: WebData.linkURL }} target="_blank">
                                                                                            <p className='mb-1'> {WebData.linkURL}</p>
                                                                                        </Link> */}
                                                  <button
                                                    className="btn btn-link weblinkbuton"
                                                    type="button"
                                                    onClick={() => {
                                                      OpenExternallink(
                                                        WebData.linkURL
                                                      );
                                                    }}
                                                  >
                                                    <p className="mb-0 exploreweblink">
                                                      {WebData.linkURL}
                                                    </p>
                                                    <button className="btn bg-darkgreen btn-icon btn-circle btn-lg m-r-2">
                                                      <i className="ion ion-md-copy"></i>
                                                    </button>
                                                  </button>
                                                </div>
                                              );
                                            }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                  {ArticleSegmentDocumentlist.length > 0 ? (
                                    <div>
                                      <div className="titlebgcontainer">
                                        <b className="mb-0">
                                          Read further{" "}
                                          {segmentinfo.isArticleSegmentDocumentDisplay ===
                                            true ? (
                                            <small className="mb-0 text-success">
                                              <b>( Published </b>)
                                            </small>
                                          ) : (
                                            <small className="mb-0 text-danger">
                                              <b>( Unpublished )</b>
                                            </small>
                                          )}
                                        </b>
                                      </div>
                                      <div className="container-fluid px-3 py-3">
                                        <div className="row pdfbtn">
                                          {ArticleSegmentDocumentlist.map(
                                            (DocumnetData) => {
                                              return (
                                                <div className="col-sm-3 text-center">
                                                  <button
                                                    onClick={(e) => {
                                                      downloadImage(
                                                        DocumnetData.filePath,
                                                        DocumnetData.originalFileName
                                                      );
                                                    }}
                                                  >
                                                    <img
                                                      src="../assets/img/new-images/Pdf.png"
                                                      alt="img"
                                                      className="img-fluid"
                                                    />
                                                  </button>
                                                  <p className="mb-0 wordbreak text2line">
                                                    {DocumnetData.originalFileName}
                                                  </p>
                                                </div>
                                              );
                                            }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </PanelBody>
                    </Panel>
                  </TabPane>
                </TabContent>
              ) : (
                <></>
              )}
            </PanelBody>
          </Panel>
        </>
      )}
    </div>
  );
};

export default Articleinfopage;
